var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('popup', {
    attrs: {
      "opened": _vm.isDisplayed
    },
    on: {
      "close": function ($event) {
        return _vm.$emit('close');
      }
    }
  }, [_c('div', {
    staticClass: "sticky top-0 z-10"
  }, [_c('transition', {
    attrs: {
      "enter-active-class": "ease-out duration-300",
      "enter-class": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
      "enter-to-class": "opacity-100 translate-y-0 sm:scale-100",
      "leave-active-class": "ease-in duration-200",
      "leave-class": "opacity-100 translate-y-0 sm:scale-100",
      "leave-to-class": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
    }
  }, [_vm.messageHeader == 'saveIsSuccess' ? _c('div', {
    staticClass: "absolute text-center bg-green-300 border-2 border-green-600 border-opacity-25 text-green-600 pt-4 pb-3 mt-13 w-8/12 left-2/12 right-2/12"
  }, [_c('icon', {
    staticClass: "inline-block mr-2",
    attrs: {
      "name": "checkmark-circle-2"
    }
  }), _vm._v("\n        " + _vm._s(_vm.messageSaveSuccess) + "\n      ")], 1) : _vm._e(), _vm._v(" "), _vm.messageHeader == 'error' ? _c('div', {
    staticClass: "absolute text-center bg-pink-300 border-2 border-pink-600 border-opacity-25 text-pink-600 pt-4 pb-3 mt-13 w-6/12 left-3/12 right-3/12"
  }, [_c('icon', {
    staticClass: "inline-block mr-2",
    attrs: {
      "name": "checkmark-circle-2"
    }
  }), _vm._v("\n        " + _vm._s(_vm.messageSaveError) + "\n      ")], 1) : _vm._e()]), _vm._v(" "), _c('save-button', {
    staticClass: "right-15 top-15",
    attrs: {
      "saving": _vm.saving
    },
    on: {
      "save": function ($event) {
        return _vm.$emit('saveRights');
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "w-full my-5 lg:my-15 2xl:my-20"
  }, [_c('h3', {
    staticClass: "mb-10"
  }, [_vm._v("Gérer les droits d'accès")]), _vm._v(" "), _c('div', {
    staticClass: "w-full text-left text-pink-600 text-lg mb-10 mx-5 lg:mx-15 2xl:mx-20"
  }, [_vm._v("\n      DROITS ET RESTRICTIONS\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-start mx-5 lg:mx-15 2xl:mx-20"
  }, [_c('div', {
    staticClass: "flex-none"
  }, [_vm.listModulesPages.filter(function (m) {
    return _vm.permissions.includes(m.name + '_read') && m.name != _vm.constants.MODULE_NEOPASS_FORM_DEPOT_DOCUMENTS;
  }).length > 0 ? _c('div', [_c('checkbox-indigo', {
    attrs: {
      "name": "Lecture",
      "libelle": "LECTURE",
      "color-libelle": "text-indigo-600",
      "size-libelle": "text-base",
      "value": (_vm.neopassFormRights.read || {}).all
    },
    on: {
      "input": function (newValue) {
        _vm.$emit('check', {
          type: 'read',
          module: 'all',
          page: null,
          newValue: newValue,
          checkall: true,
          decheckall: false
        });
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._l(_vm.listModulesPages.filter(function (m) {
    return _vm.permissions.includes(m.name + '_read') && m.name != _vm.constants.MODULE_NEOPASS_FORM_DEPOT_DOCUMENTS;
  }), function (mod, numMod) {
    return _c('div', {
      key: numMod,
      staticClass: "m-3"
    }, [_c('div', [_c('checkbox-indigo', {
      staticClass: "mb-1.5",
      attrs: {
        "name": mod.name,
        "libelle": mod.display_name,
        "value": ((_vm.neopassFormRights.read || {})[mod.name] || {}).all,
        "size-libelle": "text-base"
      },
      on: {
        "input": function (newValue) {
          _vm.$emit('check', {
            type: 'read',
            module: mod.name,
            page: 'all',
            newValue: newValue,
            checkall: true,
            decheckall: true
          });
        }
      }
    })], 1), _vm._v(" "), _vm._l(mod.pages.filter(function (p) {
      return _vm.permissions.includes(p.name + '_read');
    }), function (page, numPage) {
      return _c('div', {
        key: numPage
      }, [_c('checkbox-indigo', {
        attrs: {
          "name": page.name,
          "libelle": page.display_name,
          "color-libelle": "text-gray-600",
          "size-libelle": "text-base",
          "weight-libelle": "font-light",
          "value": ((_vm.neopassFormRights.read || {})[mod.name] || {})[page.name]
        },
        on: {
          "input": function (newValue) {
            _vm.$emit('check', {
              type: 'read',
              module: mod.name,
              page: page.name,
              newValue: newValue,
              checkall: false,
              decheckall: true
            });
          }
        }
      })], 1);
    })], 2);
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "flex-grow"
  }), _vm._v(" "), _c('div', {
    staticClass: "flex-none"
  }, [_vm.listModulesPages.filter(function (m) {
    return _vm.permissions.includes(m.name + '_edit') && m.name != _vm.constants.MODULE_NEOPASS_FORM_DEPOT_DOCUMENTS;
  }).length > 0 ? _c('div', [_c('checkbox-indigo', {
    staticClass: "w-1/2",
    attrs: {
      "name": "Ecriture",
      "libelle": "ECRITURE",
      "color-libelle": "text-indigo-600",
      "size-libelle": "text-base",
      "value": (_vm.neopassFormRights.edit || {}).all
    },
    on: {
      "input": function (newValue) {
        _vm.$emit('check', {
          type: 'edit',
          module: 'all',
          page: null,
          newValue: newValue,
          checkall: true,
          decheckall: false
        });
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._l(_vm.listModulesPages.filter(function (m) {
    return _vm.permissions.includes(m.name + '_edit') && m.name != _vm.constants.MODULE_NEOPASS_FORM_DEPOT_DOCUMENTS;
  }), function (mod, numMod) {
    return _c('div', {
      key: numMod,
      staticClass: "m-3"
    }, [_c('div', [_c('checkbox-indigo', {
      staticClass: "mb-1.5",
      attrs: {
        "name": mod.name,
        "libelle": mod.display_name,
        "value": ((_vm.neopassFormRights.edit || {})[mod.name] || {}).all,
        "size-libelle": "text-base"
      },
      on: {
        "input": function (newValue) {
          _vm.$emit('check', {
            type: 'edit',
            module: mod.name,
            page: 'all',
            newValue: newValue,
            checkall: true,
            decheckall: true
          });
        }
      }
    })], 1), _vm._v(" "), _vm._l(mod.pages.filter(function (p) {
      return _vm.permissions.includes(p.name + '_edit');
    }), function (page, numPage) {
      return _c('div', {
        key: numPage
      }, [_c('checkbox-indigo', {
        attrs: {
          "name": page.name,
          "libelle": page.display_name,
          "color-libelle": "text-gray-600",
          "size-libelle": "text-base",
          "weight-libelle": "font-light",
          "value": ((_vm.neopassFormRights.edit || {})[mod.name] || {})[page.name]
        },
        on: {
          "input": function (newValue) {
            _vm.$emit('check', {
              type: 'edit',
              module: mod.name,
              page: page.name,
              newValue: newValue,
              checkall: false,
              decheckall: false
            });
          }
        }
      })], 1);
    })], 2);
  })], 2)])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }